var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fab-button',{on:{"click":_vm.openNewTicketPage}},[_vm._v("\n  add\n")])}
var staticRenderFns = []
export { render, staticRenderFns }